interface StepperProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  disabled?: boolean;
  suffix?: string;
  onChange: (value: number) => void;
}

/**
 * +/- Stepper statt Schieberegler: auf dem Handy trifft man 48px-Buttons
 * zuverlässiger als einen schmalen Slider-Griff (GDD §38).
 */
export function Stepper({ label, value, min, max, step, disabled, suffix, onChange }: StepperProps) {
  const clampedStep = (delta: number) => Math.min(max, Math.max(min, value + delta));

  return (
    <div className="flex items-center justify-between gap-3 py-2.5">
      <span className="text-sm text-fg-muted">{label}</span>
      <div className="flex items-center gap-3">
        <button
          type="button"
          disabled={disabled || value <= min}
          onClick={() => onChange(clampedStep(-step))}
          aria-label={`${label} verringern`}
          className="flex h-11 w-11 items-center justify-center rounded-full bg-surface-2 text-lg font-bold text-fg disabled:opacity-30"
        >
          −
        </button>
        <span className="w-14 text-center font-display tabular-nums font-semibold">
          {value}
          {suffix}
        </span>
        <button
          type="button"
          disabled={disabled || value >= max}
          onClick={() => onChange(clampedStep(step))}
          aria-label={`${label} erhöhen`}
          className="flex h-11 w-11 items-center justify-center rounded-full bg-surface-2 text-lg font-bold text-fg disabled:opacity-30"
        >
          +
        </button>
      </div>
    </div>
  );
}
